module.exports = __webpack_public_path__ + "img/Logos-20.355a39a5.png";